import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom'; // dodano useParams na wypadek pobierania po ID
import axios from 'axios';
import '../styles/AdminNotPageInpost.css';
import ButtonRegular from './ui/ButtonRegular';

const NotPageInpost = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams(); // Jeśli masz id w ścieżce np. /admin/inpost/:id

    const apiUrl = process.env.REACT_APP_API_URL || '';
    const stateForm = location.state?.form || null;
    
    const [form, setForm] = useState(stateForm);
    const [loading, setLoading] = useState(false); 
    const [error, setError] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const [parcel, setParcel] = useState({
        weight: '',
        length: '',
        width: '',
        height: '',
    });

    useEffect(() => {
        if (!form && id) {
            const fetchForm = async () => {
                setLoading(true);
                try {
                    const res = await axios.get(`${apiUrl}/api/forms/${id}`); // dostosuj endpoint
                    setForm(res.data);
                } catch (err) {
                    console.error(err);
                    setError('Nie udało się pobrać danych formularza z serwera.');
                } finally {
                    setLoading(false);
                }
            };
            fetchForm();
        }
    }, [id, form, apiUrl]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setParcel(prev => ({ ...prev, [name]: value }));
    };

    const products = form?.products || [];
    const totalProductsPrice = products.reduce((sum, item) => sum + (item.price || 0), 0);

    const handleSendToInpost = async () => {
        setError('');
        setSuccessMsg('');

        if (!parcel.weight || !parcel.length || !parcel.width || !parcel.height) {
            return setError('Uzupełnij dane paczki.');
        }

        try {
            if (!form?.customerData) {
                return setError('Brak danych klienta.');
            }

            if (!form?.shippingData) {
                return setError('Brak danych wysyłkowych.');
            }

            const sender = {
                company_name: "Kwiaty z gór",
                first_name: "Ewa",
                last_name: "Rapta",
                email: "kontakt@kwiatyzgor.pl",
                phone: "792 825 301",
                address: {
                    street: "Raba Niżna",
                    building_number: "165",
                    city: "Raba Niżna",
                    post_code: "34-730",
                    country_code: "PL"
                }
            };

            const building = form.shippingData.building?.toString().trim() || '';
            const apartment = form.shippingData.apartment?.toString().trim() || '';

            const buildingNumberCombined = apartment ? `${building} / ${apartment}` : building;

            const receiver = {
                company_name: form.customerData.vatInvoice ? form.customerData.companyName : undefined,
                first_name: form.customerData.firstName?.trim(),
                last_name: form.customerData.lastName?.trim(),
                email: form.customerData.email?.trim(),
                phone: form.customerData.phone?.trim(),
                address: {
                    street: form.shippingData.street?.trim() || '', 
                    building_number: buildingNumberCombined,
                    city: form.shippingData.city?.trim() || '',
                    post_code: form.shippingData.postalCode?.trim() || '',
                    country_code: 'PL',
                }
            };
            
            const parcels = [
                {
                    id: String(form.formNumber),
                    dimensions: {
                        length: Number(parcel.length) * 10,
                        width: Number(parcel.width) * 10,
                        height: Number(parcel.height) * 10,
                        unit: "mm"
                    },
                    weight: {
                        amount: Number(parcel.weight),
                        unit: "kg"
                    },
                    is_non_standard: false
                }
            ];

            const shipmentData = {
                sender,
                receiver,
                parcels,
                insurance: {
                    amount: totalProductsPrice + 25,
                    currency: "PLN"
                },
                service: "inpost_courier_standard",
                reference: 'Formularz ' + (form.formNumber),
                orderId: form.formNumber 
            };

            console.log('📦 FULL SHIPMENT (FORM):', shipmentData);

            const res = await axios.post(`${apiUrl}/api/shipments/inpostCourier`, shipmentData);
            setSuccessMsg(res.data.message || 'Nadano');
        } catch (err) {
            console.error('❌ Błąd:', err.response?.data || err.message);
            setError(err.response?.data?.message || 'Błąd zapisu.');
        }
    };

    // Obsługa stanów wyjątkowych
    if (loading) return <p style={{ color: 'white', padding: '20px' }}>Ładowanie danych...</p>;
    
    // Jeśli nie ma danych w stanie, zamiast białego ekranu pokazujemy błąd i przycisk powrotu
    if (!form) {
        return (
            <div className="form-container" style={{ padding: '20px', color: 'white' }}>
                <h2>Brak danych formularza</h2>
                <p style={{ color: '#ff4d4d' }}>
                    Komponent nie otrzymał danych obiektu. Upewnij się, że przechodzisz do tej strony klikając odpowiedni przycisk w panelu.
                </p>
                <ButtonRegular onClick={() => navigate(-1)}>Powrót</ButtonRegular>
            </div>
        );
    }

    return (
        <div className="form-container">
            <div className="form-content">
                <h1 className="form-title">Wysyłka InPost (Formularz)</h1>
                <h3 className="form-subtitle">
                    Numer formularza: {form.formNumber || form._id}
                </h3>

                {/* 📦 Produkty */}
                <section className="form-section">
                    <h2>Produkty</h2>
                    <table className="products-table">
                        <thead>
                            <tr>
                                <th style={{ color: 'white' }}>#</th>
                                <th style={{ color: 'white' }}>Nazwa</th>
                                <th style={{ textAlign: 'right', color: 'white' }}>Cena</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map((item, i) => {
                                const name = item.name || 'Brak nazwy';
                                const price = item.price || 0;

                                return (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{name}</td>
                                        <td style={{ textAlign: 'right' }}>
                                            {price.toFixed(2)} PLN
                                        </td>
                                    </tr>
                                );
                            })}
                            <tr>
                                <td colSpan={1} style={{ fontWeight: 'bold' }}>Wysyłka:</td>
                                <td colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                    {form.deliveryMethod || 'Nie wybrano'}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>Razem produkty</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                    {totalProductsPrice.toFixed(2)} PLN
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>

                {/* 👤 Dane klienta */}
                <section className="form-section">
                    <h2>Klient</h2>
                    <p>Imię: {form.customerData?.firstName}</p>
                    <p>Nazwisko: {form.customerData?.lastName}</p>
                    {form.customerData?.vatInvoice && form.customerData?.companyName && (
                        <>
                            <p>Firma: {form.customerData.companyName}</p>
                            <p>NIP: {form.customerData.taxId}</p>
                        </>
                    )}
                    <p>Telefon: {form.customerData?.phone}</p>
                    <p>Email: {form.customerData?.email}</p>
                </section>

                {/* 🏠 Dane wysyłki */}
                <section className="form-section">
                    <h2>Dane wysyłki</h2>
                    <p>Kod pocztowy: {form.shippingData?.postalCode}</p>
                    <p>Miasto: {form.shippingData?.city}</p>
                    <p>Ulica: {form.shippingData?.street}</p>
                    <p>Numer budynku: {form.shippingData.building}</p>
                    <p>Numer lokalu: {form.shippingData.apartment}</p>
                </section>

                {/* 📦 Dane paczki */}
                <section className="form-section">
                    <h2>Dane paczki</h2>
                    <input type="number" placeholder="Waga (kg)" name="weight" value={parcel.weight} onChange={handleChange} />
                    <input type="number" placeholder="Długość (cm)" name="length" value={parcel.length} onChange={handleChange} />
                    <input type="number" placeholder="Szerokość (cm)" name="width" value={parcel.width} onChange={handleChange} />
                    <input type="number" placeholder="Wysokość (cm)" name="height" value={parcel.height} onChange={handleChange} />

                    <ButtonRegular onClick={handleSendToInpost}>
                        Wyślij do InPost
                    </ButtonRegular>

                    {successMsg && <p className="success-text">{successMsg}</p>}
                    {error && <p className="error-text">{error}</p>}
                </section>

                <ButtonRegular onClick={() => navigate(-1)}>
                    Powrót
                </ButtonRegular>
            </div>
        </div>
    );
};

export default NotPageInpost;